import { render, staticRenderFns } from "./Campaigns.vue?vue&type=template&id=780157f1&"
import script from "./Campaigns.vue?vue&type=script&lang=js&"
export * from "./Campaigns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1771009219/src/capas-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('780157f1')) {
      api.createRecord('780157f1', component.options)
    } else {
      api.reload('780157f1', component.options)
    }
    module.hot.accept("./Campaigns.vue?vue&type=template&id=780157f1&", function () {
      api.rerender('780157f1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Brand/Campaigns.vue"
export default component.exports